import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { AdminService } from '../../../services/admin.service';
import { AdminUserRow } from '../../../models/admin-user.model';

@Component({
  selector: 'app-users-preview-card',
  standalone: false,
  templateUrl: './users-preview-card.html',
})
export class UsersPreviewCard implements OnInit, OnDestroy {
  private readonly _destroy$ = new Subject<void>();

  rows: AdminUserRow[] = [];
  isLoading = true;

  constructor(private adminService: AdminService) {}

  ngOnInit(): void {
    this.adminService.getUsers({ perPage: 5 })
      .pipe(takeUntil(this._destroy$))
      .subscribe(({ rows }) => {
        this.rows = rows;
        this.isLoading = false;
      });
  }

  primaryOrg(user: AdminUserRow): string {
    return user.organizations[0]?.name ?? '-';
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
